<template>
    <section class="company-section _preview-section">
        <div class="section-inner">
            <div class="company-section-inner">

                <!--Detail-->
                <div class="company-section-inner-item">
                    <h2 class="heading-section"><span>Company Info</span></h2>

                    <div class="company-item-wrap">

                        <div class="group">
                            <!--Title / Sns-->
                            <h3>
                                <div class="title" v-if="$store.state.register.form.company_name">
                                    <span>{{$store.state.register.form.company_name}}</span>
                                </div>
                                <!-- <div class="sns">
                                    <a :href="$store.state.register.form.company_facebook_url" class="md_icon-btn _outline _hover" target="_blank" v-if="$store.state.register.form.company_facebook_url">
                                        <div class="inner"><SvgIconSnsFacebook /></div>
                                    </a>
                                    <a :href="$store.state.register.form.company_twitter_url" class="md_icon-btn _outline _hover" target="_blank" v-if="$store.state.register.form.company_twitter_url">
                                        <div class="inner"><SvgIconSnsTwitter /></div>
                                    </a>
                                    <a :href="$store.state.register.form.company_instagram_url" class="md_icon-btn _outline _hover" target="_blank" v-if="$store.state.register.form.company_instagram_url">
                                        <div class="inner"><SvgIconSnsInstagram /></div>
                                    </a>
                                    <a :href="$store.state.register.form.company_line_url" class="md_icon-btn _outline _hover" target="_blank" v-if="$store.state.register.form.company_line_url">
                                        <div class="inner"><SvgIconSnsLine /></div>
                                    </a>
                                </div> -->
                            </h3>

                            <!--Contact-->
                            <div class="company-contact">
                                <p style="color: #999999;">
                                    <span>{{$store.state.register.form.company_phonetic}}</span>
                                </p>
                                <p>
                                    <a v-if="$store.state.register.form.google_map_url" :href="$store.state.register.form.google_map_url" class="md_text-link _left _pin" target="_blank">
                                        <span>
                                            <template v-if="$store.state.register.form.company_post_code">〒{{$store.state.register.form.company_post_code}}</template>
                                            {{$store.state.register.form.company_address}}
                                        </span>
                                    </a>
                                    <a v-if="!$store.state.register.form.google_map_url" class="md_text-link _left _pin" target="_blank">
                                        <span>
                                            <template v-if="$store.state.register.form.company_post_code">〒{{$store.state.register.form.company_post_code}}</template>
                                            {{$store.state.register.form.company_address}}
                                        </span>
                                    </a>
                                </p>
                                <p>
                                    <a :href="'tel:' + $store.state.register.form.company_tel" class="md_text-link _left _tel" v-if="$store.state.register.form.company_tel">
                                        <span>{{$store.state.register.form.company_tel}}</span>
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div class="company-detail" v-if="$store.state.register.form.company_concept">
                            <p>{{$store.state.register.form.company_concept}}</p>
                        </div>

                    </div>
                </div>

                <!--Contacts-->
                <!-- <div class="company-section-inner-item" v-if="showBrand">
                    <h2 class="heading-section"><span>Contact</span></h2>

                    <div class="contact-item-wrap">

                        <a v-bind:href="mailTo" class="btn_common _square">
                            <div class="md_svg-icon">
                                <SvgIconMail />
                            </div>
                            <span>メール</span>
                            <div class="chevron"></div>
                        </a>

                        <a v-bind:href="telTo" class="btn_common _square">
                            <div class="md_svg-icon">
                                <SvgIconPhone />
                            </div>
                            <span>電話</span>
                            <div class="chevron"></div>
                        </a>

                    </div>

                </div> -->

            </div><!--/.company-section-inner-->
        </div><!--/.section-inner-->
    </section>
</template>

<script>
    import SvgIconClipBoard from '@/components/EndUser/svg/SvgIconClipBoard'
    import SvgIconSnsFacebook from '@/components/EndUser/svg/SvgIconSnsFacebook'
    import SvgIconSnsTwitter from '@/components/EndUser/svg/SvgIconSnsTwitter'
    import SvgIconSnsInstagram from '@/components/EndUser/svg/SvgIconSnsInstagram'
    import SvgIconSnsLine from '@/components/EndUser/svg/SvgIconSnsLine'
    import SvgIconMail from '@/components/EndUser/svg/SvgIconMail'
    import SvgIconChat from '@/components/EndUser/svg/SvgIconChat'
    import SvgIconAtmark from '@/components/EndUser/svg/SvgIconAtmark'
    import SvgIconPhone from '@/components/EndUser/svg/SvgIconPhone'

    export default {
        components: {
            SvgIconClipBoard,
            SvgIconSnsFacebook,
            SvgIconSnsTwitter,
            SvgIconSnsInstagram,
            SvgIconSnsLine,
            SvgIconMail,
            SvgIconChat,
            SvgIconAtmark,
            SvgIconPhone,
        },
        computed: {
            showBrand() {
                var url = location.pathname;
                return url.indexOf( '/brand' ) != -1;
            },
            showShowRoom() {
                var url = location.pathname;
                return url.indexOf( '/showroom' ) != -1;
            },
            pageTypeStep10() {
                var url = location.pathname;
                if (url.indexOf( 'registration' ) != -1) {
                    //初回編集
                    return 0;
                } else if (url.indexOf( '/detail' ) != -1) {
                    //管理画面での編集
                    return 1;
                } else {
                    //エンドユーザー側での表示
                    return 2;
                }
            },
            personalAndBasic() {
                if (this.$store.state.detail.set.personalAndBasic) {
                    return true;
                }
            },
            unitAndBasic() {
                if (this.$store.state.detail.set.unitAndBasic) {
                    return true;
                }
            },
            activeBasicBrand() {
                if (this.$store.state.detail.set.activeBasicBrand) {
                    return true;
                }
            },
            adminAndBasic() {
                if (this.$store.state.detail.set.adminAndBasic) {
                    return true;
                }
            },
            mailTo() {
                if (this.$store.state.detail.set.brand.mail) {
                    var mail = 'mailto:' + this.$store.state.detail.set.brand.mail;
                    return mail;
                }
            },
            telTo() {
                if (this.$store.state.detail.set.brand.tel) {
                    var tel = 'tel:' + this.$store.state.detail.set.brand.tel;
                    return tel;
                }
            },
            personalAndShowRoom() {
                return this.$store.state.detail.set.personalAndShowRoom;
            },
            unitAndShowRoom() {
                return this.$store.state.detail.set.unitAndShowRoom;
            },
            basicAndShowRoom() {
                return this.$store.state.detail.set.basicAndShowRoom;
            },
            showRoomAndBasic() {
                return this.$store.state.detail.set.showRoomAndBasic;
            },
        }
    }
</script>